import React, { useState } from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './ui/command';

export const DEFAULT_LANGUAGE = 'Português';

export const LANGUAGES = [
  'Português', 'Inglês', 'Espanhol', 'Francês', 'Alemão', 'Italiano', 'Chinês (Mandarim)', 'Japonês', 'Coreano', 'Russo',
  'Árabe', 'Hindi', 'Bengali', 'Urdu', 'Indonésio', 'Turco', 'Vietnamita', 'Persa', 'Suaíli', 'Holandês', 'Não identificada'
];

export const LanguageSelect = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open} data-testid="book-form-idioma"
          className="flex h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm">
          <span>{value || DEFAULT_LANGUAGE}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[260px]" align="start">
        <Command>
          <CommandInput placeholder="Pesquisar língua..." data-testid="book-form-idioma-search" />
          <CommandList>
            <CommandEmpty>Nenhuma língua encontrada.</CommandEmpty>
            <CommandGroup>
              {LANGUAGES.map((lang) => (
                <CommandItem key={lang} value={lang} keywords={[lang.normalize('NFD').replace(/[\u0300-\u036f]/g, '')]} onSelect={() => { onChange(lang); setOpen(false); }} data-testid={`idioma-option-${lang}`}>
                  <Check className="mr-2 h-4 w-4" style={{ opacity: (value || DEFAULT_LANGUAGE) === lang ? 1 : 0 }} />
                  {lang}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
